import React, { useState } from 'react';
import axios from 'axios';
import { AJAX_URL } from '../../../config/index.js';
import { wlGetDeviceInfo } from '../helpers.js';

const LoginForm = ({ handleUserLoggedIn }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleLogin = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');

    const formData = new URLSearchParams();
    formData.append('action', 'fl_login_user');
    formData.append('email', email);
    formData.append('username', email);
    formData.append('password', password);
    formData.append('device', wlGetDeviceInfo());

    try {
      const response = await axios({
        method: 'post',
        url: AJAX_URL,
        data: formData,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      });

      if (response.data.success) {
        handleUserLoggedIn(response.data.data.username);

        const jwtResponse = await axios({
          method: 'post',
          url: '/wp-json/jwt-auth/v1/token',
          data: formData
        });
        localStorage.setItem('jwt', jwtResponse.data.data.token);
        const expiresAt = new Date();
        expiresAt.setMinutes(expiresAt.getMinutes() + 10);
        localStorage.setItem('jwtExpiresAt', expiresAt);
      } else {
        setError(response.data.data);
      }
    } catch (error) {
      setError('An error occurred. Please try again.');
    }

    setLoading(false);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <form className="fuselight-login-form" onSubmit={handleLogin}>
      <div>
        <label>Email:</label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
        />
      </div>
      <div className="password-field">
        <label>Password:</label>
        <div style={{ position: 'relative' }}>
          <input
            type={showPassword ? 'text' : 'password'}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
          <span onClick={togglePasswordVisibility}>
            {showPassword ? 'Hide' : 'Show'}
          </span>
        </div>
      </div>
      <div className="form-buttons">
        <button type="submit" disabled={loading}>
          {loading ? 'Logging in...' : 'Log In'}
        </button>
        <a href="/my-account/lost-password/" className="lost-password">
          Forgot Password?
        </a>
      </div>
      {error && <p className="login-error">{error}</p>}
    </form>
  );
};

export default LoginForm;
